const {
  RapidsAutocomplete,
} = require("@seo/rapids_autocomplete/src/js/RapidsAutocomplete");

const { initializeReportCommentModal } = require("./report-comment-modal");
const { ensureCsrf, applyCsrf } = require("./csrf");

enum FirstStepAnswer {
  Yes = 1,
  No = 0,
}

const SUSPECTED_SCAM_CATEGORY = "suspected_scam";

RapidsAutocomplete.setConfigs({
  apiKey: process.env.RAPIDS_API_KEY,
  apiUrl: "https://www.reversephone.com/rpds/lookup",
  params: {
    maxResults: 5,
  },
  removeFocusAfterSelection: true,
});

(function ($, window, document) {
  var ProgressBar = require("progressbar.js");

  //Comment form
  $(function () {
    initializeReportCommentModal();

    // Warm the token while the visitor is still filling the form in, so the
    // submit itself does not have to wait on a round trip.
    $(document).on(
      "focusin",
      ".comment-form-wrapper form, [data-spam-vote-form]",
      function () {
        ensureCsrf();
      },
    );

    $('input[name="comment_key"]').each(function () {
      $(this).val("no bots");
    });

    var $leaveCommentBtn = $("#leave-comment-btn");
    var $btnFAQ = $("#btn-faq");
    var $faqSection = $("#faq");
    var $leaveCommentWrapperBottom = $("#leave-a-comment-wrapper-bottom");

    $btnFAQ.on("click", function () {
      $.smoothScroll({
        scrollTarget: $faqSection,
        offset: -($("header").outerHeight() + 10),
        easing: "linear",
        speed: 0,
      });
    });

    $leaveCommentBtn.on("click", function () {
      var $target = $leaveCommentWrapperBottom;
      $.smoothScroll({
        scrollTarget: $target,
        offset: -($("header").outerHeight() + 10),
        easing: "linear",
        speed: 0,
        afterScroll: function () {
          const textarea = document.querySelector<HTMLTextAreaElement>(
            "#leave-a-comment-wrapper-bottom textarea[name=comment]",
          );
          textarea.focus({
            preventScroll: true,
          });
        },
      });
    });

    $("[data-spam-vote-form]").on("submit", function (event) {
      event.preventDefault();

      var submitter = (
        event.originalEvent as Event & { submitter?: HTMLButtonElement }
      ).submitter;

      if (!submitter) {
        return;
      }

      var form = this as HTMLFormElement;
      var $form = $(form);
      var $buttons = $form.find<HTMLButtonElement>("[name=vote]");
      var $wrapper = $form.closest("[data-spam-vote-wrapper]");
      var $status = $wrapper.find("[data-spam-vote-status]");
      var voteValue = submitter.value;

      $buttons.prop("disabled", true);

      // The cached page ships the token field empty, so it has to be named and
      // filled before the form data is collected.
      ensureCsrf()
        .then(function () {
          var formData = new FormData(form);
          formData.set("vote", voteValue);

          return fetch(form.action, {
            method: "POST",
            body: formData,
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          });
        })
        .then(function (response) {
          return response.json().then(function (data) {
            applyCsrf(data);

            if (!response.ok || !data.success) {
              $buttons.prop("disabled", false);
            }

            $status
              .text(data.message || "Thanks for your feedback.")
              .removeClass("d-none");
          });
        })
        .catch(function () {
          $buttons.prop("disabled", false);
          $status.text("Unable to submit feedback.").removeClass("d-none");
        });
    });

    $(".money-range").each((i, container) => {
      const numberInput = $(container).find('input[type="number"]').first();

      const setValue = () => {
        let value = numberInput.val();

        if (value === "") {
          numberInput.attr("value", "");
        } else {
          numberInput.attr("value", Number(value));
        }
      };

      numberInput.on("input", setValue);
      setValue();
    });

    function showSecondStep(form: HTMLElement, answer: FirstStepAnswer) {
      if (answer == FirstStepAnswer.No) {
        $(form)
          .find(".step-2 :input:not(button):not([name=cf-turnstile-response])")
          .val("");
        $(form).find(".step-2 [type=range]").val(1).trigger("input");
        $(form).find(".yes-option").addClass("d-none");
        $(form).find("[name=opt_comment_category]").prop("required", false);
      } else {
        $(form).find(".yes-option").first().removeClass("d-none");
        $(form).find("[name=opt_comment_category]").prop("required", true);
        const categorySelect = $(form).find("#opt_comment_category");
        if (categorySelect.val() != "") {
          categorySelect.trigger("change");
        }
      }

      $(form).find(".step-2 .question-wrapper").removeClass("mt-0");
      $(form)
        .find(".step-2 .question-wrapper:not(.d-none)")
        .first()
        .addClass("mt-0");
      $.smoothScroll({
        scrollTarget: $leaveCommentWrapperBottom,
        offset: -($("header").outerHeight() + 10),
        easing: "linear",
        speed: 0,
      });
      showScreen(form, 2);
    }

    function showScreen(form: HTMLElement, number: number) {
      $(form).find(".step").addClass("d-none");
      $(form)
        .find(".step-" + number)
        .removeClass("d-none");
    }

    function formSectionIsValid(form: HTMLElement, selector: string) {
      const inputs = $(form).find(selector + " :input:not(button)");

      let valid = true;
      for (let i = 0; i < inputs.length; i++) {
        if (!$(form).data("validator").element(inputs[i]) && valid) {
          valid = false;
        }
      }

      return valid;
    }

    $(".comment-form-wrapper form").each(function () {
      let currentScreen = 1;
      const stateInput = $(this).find("[name=home_state]").first();
      const cityInput = $(this).find("[name=home_city]").first();
      stateInput.on("change", () => {
        cityInput.val("");
      });

      const categorySelect = $(this).find("#opt_comment_category").first();
      const categoryInput = $(this).find("[name=opt_comment_category]").first();
      const categoryOtherInput = $(this)
        .find("#opt_comment_category_other")
        .first();
      categoryOtherInput.on("input", () => {
        let value = categoryOtherInput.val() as string;
        if (!value || (!!value && value.trim() == "")) {
          value = categorySelect.val() as string;
        }
        categoryInput.val(value);
      });
      categorySelect.on("change", () => {
        const scamFields = $(this).find(".scam-field");
        if (categorySelect.val() == SUSPECTED_SCAM_CATEGORY) {
          scamFields.removeClass("d-none");
        } else {
          $(scamFields).find(":input:not(button)").val("");
          $(scamFields).find("[type=range]").val(0).trigger("input");
          scamFields.addClass("d-none");
        }

        if (categorySelect.val() == "Other") {
          categoryOtherInput.removeClass("d-none");
          categoryOtherInput.val("");
        } else {
          categoryOtherInput.addClass("d-none");
        }

        categoryInput.val(categorySelect.val() as string);
        $(this).data("validator").element(categoryInput); // to trigger validations
      });

      const scamTypeSelect = $(this).find("#opt_scam_type").first();
      const scamTypeInput = $(this).find("[name=opt_scam_type]").first();
      const scamTypeOtherInput = $(this).find("#opt_scam_type_other").first();
      scamTypeOtherInput.on("input", () => {
        let value: string = scamTypeOtherInput.val() as string;
        if (!value || (!!value && value.toString().trim() == "")) {
          value = scamTypeSelect.val() as string;
        }
        scamTypeInput.val(value);
      });
      scamTypeSelect.on("change", () => {
        if (scamTypeSelect.val() == "Other") {
          scamTypeOtherInput.removeClass("d-none");
          scamTypeOtherInput.val("");
        } else {
          scamTypeOtherInput.addClass("d-none");
        }
        scamTypeInput.val(scamTypeSelect.val() as string);
        $(this).data("validator").element(scamTypeInput); // to trigger validations
      });

      const scamAmountInput = $(this).find("[name=opt_scam_amount]").first();
      const notApplicable = $(this).find("#not-applicable").first();
      notApplicable.on("change", () => {
        if (notApplicable.is(":checked")) {
          scamAmountInput.val(0);
        } else {
          scamAmountInput.val("");
        }
        scamAmountInput.trigger("input");
        scamAmountInput.prop("disabled", notApplicable.is(":checked"));
      });

      const yesButton = $(this).find(".yes-button").first();
      yesButton.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (formSectionIsValid(this, ".step-1")) {
          currentScreen++;
          showSecondStep(this, FirstStepAnswer.Yes);
        }
      });

      const noButton = $(this).find(".no-button").first();
      noButton.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (formSectionIsValid(this, ".step-1")) {
          currentScreen++;
          showSecondStep(this, FirstStepAnswer.No);
        }
      });

      const backButton = $(this).find(".btn-back").first();
      backButton.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        showScreen(this, --currentScreen);
      });

      new RapidsAutocomplete(this.querySelector("input.autocomplete"), {
        params: {
          searchTypes: ["city"],
          maxResults: 50,
        },
        placeholder: "Enter a City",
        notFoundText: "No City Found",
        filterFunction: (suggestion) => {
          return suggestion.state == stateInput.val();
        },
        formatResultFunc: (suggestion) => {
          return suggestion.city;
        },
      });

      $.validator.addMethod(
        "requiredIf",
        function (value, el, params) {
          let isValid = true;
          const requiredInput = $(this.currentForm)
            .find(`[name=${params[0]}]`)
            .first();
          if (
            requiredInput &&
            value.trim() == "" &&
            requiredInput.val() == params[1]
          ) {
            isValid = false;
          }
          return isValid;
        },
        "This field is required",
      );

      $(this).validate({
        ignore: ".ignore",
        rules: {
          comment: {
            minlength: 3,
            maxlength: 400,
            required: true,
          },
          email: {
            required: true,
            email: true,
          },
          call_type: {
            required: true,
          },
          opt_scam_type: {
            requiredIf: ["opt_comment_category", SUSPECTED_SCAM_CATEGORY],
          },
          opt_scam_amount: {
            requiredIf: ["opt_comment_category", SUSPECTED_SCAM_CATEGORY],
          },
          home_state: {
            requiredIf: ["opt_comment_category", SUSPECTED_SCAM_CATEGORY],
          },
          home_city: {
            requiredIf: ["opt_comment_category", SUSPECTED_SCAM_CATEGORY],
          },
          commenter_name: {
            required: true,
          },
          "cf-turnstile": {
            required: function () {
              if (turnstile.getResponse(widgetId) == undefined) {
                return true;
              } else {
                return false;
              }
            },
          },
        },
        messages: {
          comment: "Please enter your comment",
          email: "Please enter a valid email address",
          call_type:
            "Please select the type of contact you received; a call, a text, or both",
          "cf-turnstile": "Please check the box",
        },
        highlight: function (element) {
          $(element).closest(".question-wrapper").addClass("has-error");
        },
        unhighlight: function (element) {
          $(element).closest(".question-wrapper").removeClass("has-error");
        },
        errorElement: "div",
        errorClass: "invalid-feedback",
        errorPlacement: function (error, element) {
          if (element.parent(".input-group").length) {
            error.insertAfter(element.parent());
          } else if (element.parent().parent(".money-range").length) {
            error.insertAfter(element.parent().parent().parent());
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: function (form) {
          const htmlForm = form as HTMLFormElement;
          const $form = $(htmlForm);
          const $wrapper = $form.closest(".comment-form-wrapper");
          const $success = $wrapper.find("[data-comment-success]");
          const $successMessage = $wrapper.find(
            "[data-comment-success-message]",
          );
          const $error = $wrapper.find("[data-comment-error]");
          const validator = $form.data("validator");
          const submitButton = $form.find("[type=submit]");
          const originalText = submitButton.text();

          submitButton.prop("disabled", true);
          submitButton.text("Processing...");
          $error.addClass("d-none").empty();

          function resetTurnstile() {
            if (typeof turnstile !== "undefined" && widgetId !== null) {
              turnstile.reset(widgetId);
            }
          }

          function restoreSubmit() {
            submitButton.prop("disabled", false);
            submitButton.text(originalText);
            resetTurnstile();
          }

          ensureCsrf()
            .then(function () {
              return fetch(htmlForm.action, {
                method: "POST",
                body: new FormData(htmlForm),
                credentials: "same-origin",
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                },
              });
            })
            .then(function (response) {
              return response.json().then(function (data) {
                applyCsrf(data);

                if (response.ok && data.success) {
                  if (data.message) {
                    $successMessage.text(data.message);
                  }
                  $form.addClass("d-none");
                  $success.removeClass("d-none");
                  return;
                }

                restoreSubmit();

                if (data.errors) {
                  validator.showErrors(data.errors);
                }

                if (data.message) {
                  $error.text(data.message).removeClass("d-none");
                } else if (!data.errors) {
                  $error.text("Something went wrong.").removeClass("d-none");
                }
              });
            })
            .catch(function () {
              restoreSubmit();
              $error.text("Unable to submit comment.").removeClass("d-none");
            });
        },
      });
    });

    var tagIt = function (tag, tag_value) {
      var tag_data = {};
      tag_data[tag] = tag_value;
    };
    function setCommentPlaceholder() {
      var resp: string = $(this)
        .find("input[name=spammer]")
        .first()
        .val() as string;
      var isSpammer = resp.toLowerCase().substring(resp.indexOf("-") + 1);
      var phTextObj = {
        yes: "Tell everyone about this SPAMMER here.",
        no: "This caller is not a spammer -- feel free to leave a comment here.",
        unknown:
          "Share as much info as you can about " +
          PHONE_NUMBER +
          " for everyone's benefit.",
      };
      var phText = "";
      switch (isSpammer) {
        case "yes":
          phText = phTextObj.yes;
          tagIt("spammer", "Yes");
          break;
        case "no":
          phText = phTextObj.no;
          tagIt("spammer", "No");
          break;
        case "unknown":
          phText = phTextObj.unknown;
          tagIt("spammer", "Unknown");
          break;
      }

      $(this)
        .closest("form")
        .find("textarea[name=comment]")
        .attr("placeholder", phText);
    }
    if ($(".btn-radio-spammer").length > 0) {
      $(".btn-radio-spammer").on("click", setCommentPlaceholder);
      setCommentPlaceholder.call($(".btn-radio-spammer"));
    }

    $(".sp-container").each(function (e) {
      var splink = $(this).data("href");
      $(this).load(splink, function (r, s, x) {
        $(this)
          .find(".sp-link")
          .on("click", function (e) {
            var url = $(this).data("href");
            var splink = $(this).data("splink");
            if (typeof splink !== "undefined") {
              var params = { splink: splink };
              url += "?" + $.param(params);
            }
            $(this).data("target") == "_blank"
              ? window.open(url, "_blank")
              : (document.location.href = url);
          });
      });
    });

    //Charts
    // Circles
    if ($("#circles-1").length || $("#circles-fraudscan-variant").length) {
      const controller = new AbortController();

      function getCircleColor(value, max, id) {
        if (id == "circles-3") {
          if (value == 0) {
            return {
              startColor: "#61BB6D",
              endColor: "#61BB6D",
              trailColor: "rgba(67, 168, 81, 0.2)",
            };
          } else if (value > 0 && max < 50) {
            return {
              startColor: "#EAA53D",
              endColor: "#EAA53D",
              trailColor: "rgba(234, 165, 61, 0.2)",
            };
          } else if (max >= 50) {
            return {
              startColor: "#EB6B56",
              endColor: "#EB6B56",
              trailColor: "rgba(235, 107, 86, 0.2)",
            };
          }
        } else {
          if (value < 5) {
            return {
              startColor: "#61BB6D",
              endColor: "#61BB6D",
              trailColor: "rgba(67, 168, 81, 0.2)",
            };
          } else if (value <= 5 && value < 9) {
            return {
              startColor: "#EAA53D",
              endColor: "#EAA53D",
              trailColor: "rgba(234, 165, 61, 0.2)",
            };
          } else {
            return {
              startColor: "#EB6B56",
              endColor: "#EB6B56",
              trailColor: "rgba(235, 107, 86, 0.2)",
            };
          }
        }
      }

      function animateCircle() {
        var scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height(),
          elem = $("#statistic-details").offset().top,
          final = elem - windowHeight,
          distance = final - scrollTop;
        if (distance < 0) {
          $(".scoreboard-number").css("border-color", "#cccccc");

          $('[id^="circles-"]').each(function (index) {
            $(this).text("");
            var val = $(this).data("circle-val") || 0;
            var max = $(this).data("circle-max") || 1;
            var colors = getCircleColor(val, max, $(this).attr("id"));

            var circle = new ProgressBar.SemiCircle("#" + $(this).attr("id"), {
              color: colors.startColor,
              strokeWidth: 20,
              trailColor: colors.trailColor,
              trailWidth: 20,
              trailDash: "4,2",
              duration: 6000,
              easing: "easeOutQuart",
              text: {
                alignToBottom: true,
              },
              from: {
                color: colors.startColor,
                width: 1,
              },
              to: {
                color: colors.endColor,
                width: 3,
              },
            });

            if ($(this).attr("id") == "circles-3") {
              if (val == 0) {
                circle.animate(0.25);
              } else if (val > 0 && max < 50) {
                circle.animate(0.5);
              } else if (max >= 50) {
                circle.animate(1);
              }
            } else {
              if (val < 5) {
                circle.animate(0.25);
              } else if (val >= 5 && val <= 9) {
                circle.animate(0.5);
              } else if (val > 9 && val <= 19) {
                circle.animate(0.75);
              } else {
                circle.animate(1);
              }
            }
          });
          controller.abort();
        }
      }

      window.addEventListener("scroll", animateCircle, {
        signal: controller.signal,
      });
      animateCircle();
    }

    $(".btn-comment-options").on("click", function (e) {
      e.stopPropagation();
      const $reportLink = $(this).siblings(".report-comment-link");
      const isVisible = $reportLink.hasClass("show");

      $(".report-comment-link.show").removeClass("show");

      if (!isVisible) {
        $reportLink.addClass("show");
      }
    });

    $(document).on("click", function () {
      $(".report-comment-link.show").removeClass("show");
    });
  });
})(jQuery, window, document);
